import { render, staticRenderFns } from "./SubHeaderV2.vue?vue&type=template&id=5e42c7ea&scoped=true"
import script from "./SubHeaderV2.vue?vue&type=script&setup=true&lang=js"
export * from "./SubHeaderV2.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SubHeaderV2.vue?vue&type=style&index=0&id=5e42c7ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e42c7ea",
  null
  
)

export default component.exports